import { render, staticRenderFns } from "./BaseAuth.vue?vue&type=template&id=2ecd2496&scoped=true&lang=pug&"
import script from "./BaseAuth.vue?vue&type=script&lang=js&"
export * from "./BaseAuth.vue?vue&type=script&lang=js&"
import style0 from "./BaseAuth.vue?vue&type=style&index=0&id=2ecd2496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd2496",
  null
  
)

export default component.exports